// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {


    /*apiUrl: 'https://localhost:44396/api/',
    production: false,
    graphClientId: '84bf8de4-f190-4316-950f-50fb129d6c71',

    TPMResponsibleCOO: 'peter.hintner@drschaer.com',*/

    apiUrl: 'https://teamrequests.drschaer.com/api/',
    production: false,
    graphClientId: '84bf8de4-f190-4316-950f-50fb129d6c71',

    TPMResponsibleCOO: 'peter.hintner@drschaer.com'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
